import { Component } from 'react';
import './App.scss';
import Navbar from './Navbar';
import Routes from './Routes';
import projectInfo from "./projectinformation"

export default class App extends Component {
  static defaultProps = {
    projects: projectInfo
  }

  render() {
    return (
      <div className="App bg-dark text-primary" >
        <Navbar />
        <Routes projects={this.props.projects} />
      </div>
    );
  }
}

